exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-field-dropdown-menu{min-height:50px;padding:.5rem;background:#fff;border:1px solid #ddd;text-align:center;color:#aaa}", ""]);

// exports
